/**
 * Created by Jerker Nord on 2018-05-21.
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {IceIceYetiParsedGameData} from "../server/data/IceIceYetiParsedGameData";

export class IceIceYetiSpinController extends SpinController {

    constructor(){
        super();
    }

    protected parseGameData(data:IceIceYetiParsedGameData):void{

    }

    protected getStopDelay():number {
        return 0;
    }

}